import { render, staticRenderFns } from "./Detail-Payment-Refund.vue?vue&type=template&id=0a86ad40"
import script from "./Detail-Payment-Refund.vue?vue&type=script&lang=js"
export * from "./Detail-Payment-Refund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports